import i18n from '@/helpers/i18n';

export default [
  {
    _name: 'CSidebarNav',
    _children: [ 
      {
        _name: 'CSidebarNavTitle',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('users'),
        to: '/' + i18n.t('users') + '/' + i18n.t('list'),
        icon: 'cil-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('boards'),
        to: '/' + i18n.t('boards') + '/' + i18n.t('list'),
        icon: 'cil-grid',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('characters'),
        to: '/' + i18n.t('groups') + '/' + i18n.t('list'),
        icon: 'cil-user',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('keyValues'),
        to: '/' + i18n.t('keyValues') + '/' + i18n.t('list'),
        icon: 'cil-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('staticInfos'),
        to: '/' + i18n.t('staticInfos') + '/' + i18n.t('list'),
        icon: 'cil-pin',
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: i18n.t('heros'),
      //   to: '/' + i18n.t('heros') + '/' + i18n.t('list'),
      //   icon: 'cil-pin',
      // },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('profile'),
        to: '/' + i18n.t('profile'),
        icon: 'cil-user'
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('logout'),
        to: '/logout',
        icon: 'cil-power-standby'
      },
      {
        _name: 'CSidebarNavTitle',
      }
    ]
  }
]